module.exports = __webpack_public_path__ + "static/media/shopping-cart.7c7c9d2b.svg";